import { acceptHMRUpdate, defineStore } from 'pinia'
import api from '@api'
import type {
  TransportDetail,
  TransportDetailByHash,
  TransportUpdateStatus,
  Transports,
  TransportsListParams,
  TransportsExportRetrieveParams,
  TransportCancelRequestCreate,
} from '@apiTypes'

export const useTransportsStore = defineStore('transports', {
  actions: {
    fetchTransports(query: TransportsListParams) {
      return api.transports.transportsList(query)
    },
    fetchTransport(id: number) {
      return api.transports.transportsRetrieve({ id })
    },
    fetchTransportDetails(id: number) {
      return api.transports.transportsTransportDetailsRetrieve({ id })
    },
    updateTransport(id: number, params: Transports.TransportsPartialUpdate.RequestBody) {
      return api.transports.transportsPartialUpdate({ id }, params)
    },
    updateTransportDetails(id: number, data: TransportDetail) {
      return api.transports.transportsTransportDetailsCreate({ id }, data)
    },
    updateTransportStatus(id: number, data: TransportUpdateStatus) {
      return api.transports.transportsStatusCreate({ id }, data)
    },
    deleteTransport(id: number) {
      return api.transports.transportsDestroy({ id })
    },
    fetchCarrierTransportDetails(hash: string, contactHash: string) {
      return api.byHash.byHashContactsAuctionsTransportDetailsRetrieve({ contactHash, hash }, { skipAuthToken: true })
    },
    updateCarrierTransportDetails(hash: string, contactHash: string, data: TransportDetailByHash) {
      return api.byHash.byHashContactsAuctionsTransportDetailsCreate({ contactHash, hash }, data, { skipAuthToken: true })
    },
    createCancelRequest(hash: string, contactHash: string, data: TransportCancelRequestCreate) {
      return api.byHash.byHashContactsAuctionsTransportCancelRequestCreate(
        { contactHash, hash },
        data,
        { skipAuthToken: true },
      )
    },
    validateFirstStep(data: Transports.TransportsValidateFirstStepCreate.RequestBody) {
      return api.transports.transportsValidateFirstStepCreate(data)
    },
    validateSecondStep(data: Transports.TransportsValidateSecondStepCreate.RequestBody) {
      return api.transports.transportsValidateSecondStepCreate(data)
    },
    validateThirdStep(data: Transports.TransportsValidateThirdStepCreate.RequestBody) {
      return api.transports.transportsValidateThirdStepCreate(data)
    },
    downloadTransportOrderDocument(id: number) {
      return api.transports.transportsDownloadOrderRetrieve({ id }, { format: 'blob' })
    },
    exportTransports(params: TransportsExportRetrieveParams) {
      return api.transports.transportsExportRetrieve(params, { format: 'blob' })
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useTransportsStore, import.meta.hot))
